import React, { useState } from "react";
import twofactorApi from "service/twofactorApi";
import { Cookies } from "react-cookie";
import OtpInput from "react-otp-input";
import { pushNotification } from "utils/notifications";
import configs from "constants/configs";

const TwoFactorVerify = () => {
  const cookies = new Cookies();

  let userName = cookies.get("userInfo1");

  userName = userName?.replace("username=", "");

  if (!userName) window.location.href = window.mormanServer + "dang-nhap.aspx";

  const [otp, setOtp] = useState("");

  const [loading, setLoading] = useState(false);

  const verify = () => {
    if (!otp) {
      pushNotification("Vui lòng nhập mã otp", "error", "TOP_CENTER", 2000);
      return;
    }

    const payload = {
      otp: otp,
      userName: userName,
    };

    setLoading(true);

    twofactorApi
      .verifyOtp(payload)
      .then((response) => {
        if (response && response.data) {
          setLoading(false);
          const isSuccess = response.data.isSuccess;

          const message = response.data.message;

          if (!isSuccess) {
            pushNotification(message, "error", "TOP_CENTER", 2000);

            return;
          }

          const token = response.data.token;
          const cookies = new Cookies();
          cookies.set("userInfo", `token="${token}"`, { path: "/" });
          cookies.remove("userInfo1", { path: "/" });
          window.location.href = "/trang-chu/no-phai-thu.aspx";
        } else {
          pushNotification(
            "Đã có lỗi xảy ra, hãy thử lại sau",
            "error",
            "TOP_CENTER",
            2000
          );
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const sendMail = () => {
    setLoading(true);
    twofactorApi
      .sendQr(userName)
      .then((response) => {
        setLoading(false);
        if (response.data === true) {
          pushNotification(
            "Đã gửi mã QR đến mail của bạn",
            "success",
            "TOP_CENTER",
            2000
          );
        } else {
          pushNotification(
            "Đã có lỗi trong quá trình xử lý, hãy thử lại sau",
            "error",
            "TOP_CENTER",
            2000
          );
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const backToLogin = () => {
    const cookies = new Cookies();
    cookies.remove("userInfo", { path: "/" });
    cookies.remove("userInfo1", { path: "/" });
    window.location.href =  configs.mormanServer + "dang-nhap.aspx";
  };

  return (
    <div
      className="container-verify-gg"
      style={{ float: "none", margin: "auto" }}
    >
      <p>Nhập OTP</p>
      <hr />
      <div>
        <div className="row">
          <div className="col-sm-12 col-lg-12 col-12">
            <div style={{ width: "100%" }}>
              <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                renderSeparator={<span>&#160;</span>}
                renderInput={(props) => <input {...props} />}
                inputStyle={{ width: "50px", height: "50px" }}
              />
            </div>
            <div style={{ width: "300px", textAlign: "right" }}>
              <a href="#" onClick={sendMail} disabled={loading}>
                Gửi lại QR?
              </a>
            </div>
            <button
              className="btn btn-success btn-block mt-1"
              style={{ width: "200px" }}
              onClick={verify}
              disabled={loading}
            >
              Nhập
            </button>

            <button
              className="btn btn-secondary btn-block mt-1"
              style={{ width: "200px" }}
              onClick={backToLogin}
            >
              Quay trang đăng nhập
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwoFactorVerify;
